<template>
  <div>
    <v-container grid-list-md v-if="profile" class="pa-0">
      <h1>Mijn Profiel</h1>
      <br>
      <v-form
          ref="profileForm"
          v-model="valid"
          @submit.prevent="updateProfile"
          lazy-validation
      >
        <v-layout wrap>
          <v-flex xs12 sm12 md12>
            <v-text-field
              v-model="profile.name"
              label="Naam"
              required
            ></v-text-field>
            <v-text-field 
              v-model="profile.phone"
              label="Telefoon"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12>

            <h3>Locaties</h3>
              <v-list class="pa-0 no-background-color my-profile-list">
                <v-list-tile>{{ profile.practice.name }}</v-list-tile>
              </v-list>

            <br /><br />

            <h3>Diagnostieken</h3>
            <v-list class="pa-0 no-background-color my-profile-list">
              <v-list-tile  v-for="(diagnostic) in diagnostics" :key="diagnostic.id" @click.capture.stop="selectDiagnostic(diagnostic)" class="no-padding-left list-item">
                <v-list-tile-action>
                  <v-checkbox v-model="profile.diagnostics" multiple :value="diagnostic" color="blue" />
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ diagnostic.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <br><br>

            <h3>Behandelingen</h3>
            <v-list class="pa-0 no-background-color my-profile-list">
              <v-list-tile  v-for="(treatment) in treatments" :key="treatment.id" @click.capture.stop="selectTreatment(treatment)" class="no-padding-left list-item">
                <v-list-tile-action>
                  <v-checkbox v-model="profile.treatments" multiple :value="treatment" color="blue" />
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ treatment.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

          </v-flex>
          <v-flex xs12 sm12 md12>
            <br /><br />
            <v-btn
              color="success"
              class="no-border-shadow no-margin no-capitalized"
              dark
              type="submit"
            >Opslaan
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BackendService from "../services/BackendService";

export default {
  data() {
    return {
      profile: null,
      treatments: [],
      diagnostics: [], 
      valid: true
    }
  },
  created() {
    this.fetchProfile();
  },
  watch: {
    $route: "fetchPageText"
  },
  computed: mapGetters("user", ["getProfile"]),
  methods: {
    selectTreatment(treatment) {
      const index = this.profile.treatments.findIndex(t => t.id === treatment.id);
      if (index > -1) {
        this.profile.treatments.splice(index, 1);
      } else {
        this.profile.treatments.push(treatment);
      }
    },
    selectDiagnostic(diagnostic) {
      const index = this.profile.diagnostics.findIndex(d => d.id === diagnostic.id);
      if (index > -1) {
        this.profile.diagnostics.splice(index, 1);
      } else {
        this.profile.diagnostics.push(diagnostic);
      }
    },
    fetchProfile() {
      this.$store.dispatch("user/fetchProfile").then(() => {
        BackendService.getProfileOptions().then(({ data }) => {
          this.diagnostics = data.diagnostics;
          this.treatments  = data.treatments;
        });
        this.profile = this.getProfile;
      });
    },
    updateProfile() {
      this.$store.dispatch("user/updateUserProfile", this.profile)
        .then(() => {
          this.$store.dispatch("notification/add", {
            type: "success",
            message: "Profiel opgeslagen"
          });
          this.$router.push("/");
        });
    }
  },
}
</script>

<style scoped>

</style>